<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SupportVideoCenter',
            to: {
              name: 'SupportVideoCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'SupportVideoCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增Video -->
    <SupportVideoCreateEdit></SupportVideoCreateEdit>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportVideoCreateEdit from '@/views/E-6__SupportVideos/c/VideoCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SupportVideoCreateEdit,
  },
  computed: {
    ...mapState('supportvideo', ['supportvideo']),
  },
  created() {
    this.setSupportVideo({});
  },
  methods: {
    ...mapActions('supportvideo', ['setSupportVideo', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'SupportVideoCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.supportvideo.title) {
          this.errors.push('標題 required.');
        } else if (!this.supportvideo.video_category_id) {
          this.errors.push('分類 required.');
        } else if (!this.supportvideo.upload_type) {
          this.errors.push('UploadType required.');
        } else if (!this.supportvideo.url) {
          this.errors.push('請上傳檔案或影片連結');
        } else if (!this.supportvideo.preview_image) {
          this.errors.push('Preview Image required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.supportvideo).then(() => {
          this.$router.push({ name: 'SupportVideoCenter' });
        });
      }
    },
  },
};
</script>

<style></style>
